import { FilterChip } from '../FilterChip'

import { Wrapper } from './styled'

type SegmentOption = {
  value: string
  label: string
}

type SegmentedControlProps = {
  name: string
  ariaLabel: string
  options: SegmentOption[]
  value: string
  disabled?: boolean
  onChange: (value: string) => void
}

export const SegmentedControl = ({
  name,
  ariaLabel,
  options,
  value,
  disabled = false,
  onChange,
}: SegmentedControlProps) => (
  <Wrapper role="radiogroup" aria-label={ariaLabel}>
    {options.map((option) => (
      <FilterChip
        key={option.value}
        id={`${name}-${option.value}`}
        name={name}
        value={option.value}
        label={option.label}
        checked={option.value === value}
        disabled={disabled}
        onChange={() => onChange(option.value)}
      />
    ))}
  </Wrapper>
)
